export default {
  revoked: {
    value: 0,
    name: '已撤销',
    tagType: 'info',
  },
  passed: {
    value: 1,
    name: '已通过',
    tagType: 'success',
  },
  review: {
    value: 2,
    name: '待审核',
    tagType: 'warning',
  },
  rejected: {
    value: 3,
    name: '已驳回',
    tagType: 'danger',
  },
};
